export default {
  setCurrentPage: (state, payload) => {
    state.currentPage = payload.menu;
    state.currentMode = payload.mode;
  },

  setMenu: (state, payload) => {
    state.menu = payload;
  },

  setCurrentActiveMenu: (state, payload) => (state.currentActiveMenu = payload),

  setSuspendedMenu: (state, payload) => {
    state.suspendedMenu = payload;
  },

  logoff: (state) => {
    state.currentPage = '';
    state.currentMode = '';
    state.currentActiveMenu = null;
    state.menu = [];
    state.suspendedMenu = [];
  }
};
